import Gql from "./typings/gql";

export const POST_SORT_BY: Gql.Wordpress__PageFieldsEnum = "date";
export const POST_SORT_ORDER: Gql.SortOrderEnum = "DESC";
export const DATE_FORMAT_STRING = "yyyy. MM. dd.";
export const POST_PER_PAGE = 10;
